<template>
  <div class="all-wrapper menu-side with-pattern">
   <div class="auth-box-w wider">
     <div class="logo-w"><img alt="" src="../../assets/img/onetap_transparent.png" height="90"></div>
      <h4 class="auth-header">Reset your Password</h4>
      <form @submit="reset">
        <p>Enter your new password to access your account.</p>
        <div class="alert alert-danger" role="alert" v-if="errors.length" v-for="error in errors">
          {{ error }}
        </div>
         <div class="form-group">
            <label for=""> Password</label><input class="form-control" placeholder="Enter your password" type="password" v-model="password">
            <div class="pre-icon os-icon os-icon-fingerprint"></div>
         </div>
         <div class="buttons-w"><button class="btn btn-primary">Continue</button></div>
      </form>
   </div>
 </div>
</template>

<script>
export default {
  name: 'reset_password',
  metaInfo: {
    title: 'Forgot Password',
    titleTemplate: 'onetap | %s',
    meta: [
      { property: 'og:title', content: 'onetap | forgot password' },
      { property: 'og:site_name', content: 'onetap' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://onetap.gg/'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'onetap | Register' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      registerBg: [
        require('../../assets/img/de_dust2.jpg'),
      ],
      image: null,
      errors: [],
      password: null
    }
  },
  methods: {
    reset: function(e) {
      e.preventDefault();
      this.errors = [];

      if (!this.password) {
        this.errors.push('Password is required!');
        return;
      }

      this.errors.push('Submitting info, please wait.');

      this.axios.post(`${this.API_URL}/auth/reset`, { password: this.password, verification_code: this.$route.params.verification_code, user_id: this.$route.params.user_id }).then((res) => {
        this.$router.push('/auth/login');
      }).catch((err) => {
        this.errors = [];
        this.errors.push(err.response.data.message);
      });
    },
    validpassword: function (password) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(password);
    }
  },
  mounted() {
    //
  },
  created() {
    let random = Math.floor(Math.random() * this.registerBg.length);
    this.image = this.registerBg[random];
    window.$('body').removeClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    window.$('body').css('background-image', 'url("' + this.image + '")');
    window.$('body').css('background-size', 'cover');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
